import { useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPE = 'available-credit';
const DETAIL = 'detail';
const keysFactory = {
    all: (financingProgram) => [{ scope: SCOPE, financingProgram }],
    allDetails: (financingProgram) => [{ scope: SCOPE, entity: DETAIL, financingProgram }],
    detail: (id, financingProgram) => [{ scope: SCOPE, entity: DETAIL, id, financingProgram }],
};
const getAvailableCredit = async ({ queryKey: [{ id, financingProgram }], }) => {
    const response = await apiClient.get(`/${financingProgram}/creditApplication/${encodeURIComponent(id)}/availablecredit`);
    return response.data;
};
export function useGetAvailableCredit(creditApplicationId, financingProgramId, enabled) {
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.detail(creditApplicationId, financingProgramId),
        queryFn: getAvailableCredit,
        enabled: !!creditApplicationId && enabled,
    });
    return [data, isFetching];
}
